import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ImportConfirmationModal = ({
  setDuplicateConfirmationModal,
  handleDuplicateConfirmation,
  confirmationType,
  importedData,
  cutoffTime,
  type = '',
}) => {
  const { t } = useTranslation('Order');
  const [options, setOptions] = useState({
    baseChecked: true,
    allowDeliveryTomorrow: false,
    allowDuplicate: true,
  });

  const handleChange = (e) => {
    const { name, checked } = e.target;

    // If baseChecked is manually unchecked, turn off everything
    if (name === 'onlyValidRows') {
      setOptions({
        baseChecked: checked,
        allowDeliveryTomorrow: false,
        allowDuplicate: false,
      });
      return;
    }

    // If any child is checked, re-check baseChecked
    setOptions((prev) => ({
      ...prev,
      [name]: checked,
      baseChecked: checked
        ? true
        : prev.allowDeliveryTomorrow || prev.allowDuplicate,
    }));
  };
  const isAnythingChecked =
    options.baseChecked ||
    options.deliveryCheckFailed ||
    options.duplicateCheckFailed;

  return (
    <div className="modal fade show d-block add-new-fbz" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('CONFIRMATION')}</h1>
            {/* <button
              type="button"
              className="btn-close"
              onClick={() => setDuplicateConfirmationModal(false)}
            ></button> */}
          </div>
          <div className="modal-body">
            {/* {type === 'FBZ' ? (
              <h2>{t('FBZORDERIMPORTCONFIRMATION')} </h2>
            ) : (
              <h2>{t('CATERINGORDERIMPORTCONFIRMATION')} </h2>
            )} */}
            {confirmationType === 'DELIVERY' ? (
              <h2>{t('DELIVERYCONFIRMATION')} </h2>
            ) : confirmationType === 'DUPLICATE' ? (
              <h2 className="duplicate-data mb-2">
                {t('DUPLICATECONFIRMATION')}{' '}
              </h2>
            ) : (
              <h2>{t('DELIVERYANDDUPLICATECONFIRMATION')} </h2>
            )}
            {importedData && (
              <div className="modal-body p-0">
                <div className="product-inner border-0 p-0 m-0">
                  <div className="import-status mt-3">
                    {/* <h3 className="import-head">{t('VALIDATIONSTATUS')}</h3> */}

                    <div className="row">
                      {/* <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('STATUS')}:</strong>{' '}
                          {t(importedData.status)}
                        </p>
                      </div> */}
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('PROCESSEDROWS')}:
                          </strong>{' '}
                          {importedData.processed_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('VALIDROWS')}:</strong>{' '}
                          {importedData.valid_rows}
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">{t('INVALIDROWS')}:</strong>{' '}
                          {importedData.invalid_rows}
                        </p>
                      </div>
                      {cutoffTime && type !== 'LOGISTICS' && (
                        <div className="col-md-6">
                          <p>
                            <strong className="pe-2">
                              {t('TOMORROWDELIVERYROWS')}:
                            </strong>{' '}
                            {importedData.delivery_tmr_rows}
                          </p>
                        </div>
                      )}
                      <div className="col-md-6">
                        <p>
                          <strong className="pe-2">
                            {t('DUPLICATEORDERROWS')}:
                          </strong>{' '}
                          {importedData.duplicate_rows}
                        </p>
                      </div>
                    </div>

                    {importedData.error_message && (
                      <div className="errors">
                        <h4>{t('ERRORS')}:</h4>
                        <ul>
                          {importedData.error_message
                            .split(',')
                            .map((error, index) => (
                              <li key={index}>{error.trim()}</li>
                            ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div>
              <div className="import-confirm-check checkbox-group">
                {/* <label className="custom-checkbox">
            All valid rows only
                              <input
                                type="checkbox"
                                checked=''
                                onChange=''
                              />
                              <span className="checkmark"></span>
                             
                            </label> */}

                <label className="custom-checkbox mb-2">
                  {t('ALLVALIDROWSONLY')}
                  <input
                    type="checkbox"
                    name="onlyValidRows"
                    onChange={handleChange}
                    checked={options.baseChecked}
                    // disabled
                    // readOnly
                  />
                  <span className="checkmark"></span>
                </label>
                {(confirmationType === 'DELIVERY' ||
                  confirmationType === 'DUPLICATEANDDELIVERY') && (
                  <>
                    <label className="custom-checkbox mb-2">
                      {type === 'FBZ'
                        ? t('CUTOFFMESSAGEFBZ')
                        : t('DELIVERYCHECKENTRIES[4PMCONDTITION]')}
                      <input
                        type="checkbox"
                        name="allowDeliveryTomorrow"
                        checked={options.allowDeliveryTomorrow}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </>
                )}
                {(confirmationType === 'DUPLICATE' ||
                  confirmationType === 'DUPLICATEANDDELIVERY') && (
                  <label className="custom-checkbox">
                    {t('DUPLICATEENTRIES')}
                    <input
                      type="checkbox"
                      name="allowDuplicate"
                      checked={options.allowDuplicate}
                      onChange={handleChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                )}
              </div>
            </div>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => setDuplicateConfirmationModal(false)}
              >
                {t('CANCEL')}
              </button>

              <button
                className={`save ${!isAnythingChecked ? 'disable-btn' : ''}`}
                onClick={() => handleDuplicateConfirmation(options)}
                disabled={!isAnythingChecked}
              >
                {t('UPDATE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ImportConfirmationModal;
